export const MEMBER_LIST_ID = "MEMBER_LIST_ID";
export const MEMBER_LIST_REFERRALS_ID = "MEMBER_LIST_REFERRALS_ID";
export const REFERRED_MEMBERS_LIST_ID = "REFERRED_MEMBERS_LIST_ID";
export const TRANSACTIONS_LIST_ID = "TRANSACTIONS_LIST_ID";
export const SEGMENTS_LIST_ID = "SEGMENTS_LIST_ID";
export const SEGMENTS_ASSOCIATED_CAMPAIGNS_LIST_ID =
  "SEGMENTS_ASSOCIATED_CAMPAIGNS_LIST_ID";
export const SEGMENTS_ASSOCIATED_REWARDS_LIST_ID =
  "SEGMENTS_ASSOCIATED_REWARDS_LIST_ID";
export const SEGMENTS_ASSOCIATED_ACHIEVEMENTS_LIST_ID =
  "SEGMENTS_ASSOCIATED_ACHIEVEMENTS_LIST_ID";
export const LOGS_LIST_ID = "LOGS_LIST_ID";
export const CAMPAIGN_LIST_ID = "CAMPAIGN_LIST_ID";
export const REFERRAL_LIST_ID = "REFERRAL_LIST_ID";
export const CUSTOM_EVENTS_LIST_ID = "CUSTOM_EVENTS_LIST_ID";
export const CUSTOM_EVENTS_SCHEMA_LIST_ID = "CUSTOM_EVENTS_SCHEMA_LIST_ID";
export const UNIT_TRANSFER_LIST_ID = "UNIT_TRANSFER_LIST_ID";
export const MEMBER_UNIT_TRANSFER_LIST_ID = "MEMBER_UNIT_TRANSFER_LIST_ID";
export const REWARD_FULFILLMENT_LIST_ID = "REWARD_FULFILLMENT_LIST_ID";
export const REWARD_LIST_ID = "REWARD_LIST_ID";
export const MEMBERS_IN_SEGMENT_LIST_ID = "MEMBERS_IN_SEGMENT_LIST_ID";
export const STORE_LIST_ID = "STORE_LIST_ID";
export const ACHIEVEMENT_LIST_ID = "ACHIEVEMENT_LIST_ID";
export const TIER_LIST_ID = "TIER_LIST_ID";
export const AVAILABLE_COUPONS_LIST_ID = "AVAILABLE_COUPONS_LIST_ID";
export const ROLE_LIST_ID = "ROLE_LIST_ID";
export const ADMIN_LIST_ID = "ADMIN_LIST_ID";
export const CHANNEL_LIST_ID = "CHANNEL_LIST_ID";
export const TRANSLATION_LIST_ID = "TRANSLATION_LIST_ID";
export const REWARD_CATEGORIES_LIST_ID = "REWARD_CATEGORIES_LIST_ID";
export const SINGLE_REWARD_FULFILLMENTS_LIST_ID =
  "SINGLE_REWARD_FULFILLMENTS_LIST_ID";
export const REDEEMED_REWARDS_LIST_ID = "REDEEMED_REWARDS_LIST_ID";
export const WALLET_TYPES_LIST_ID = "WALLET_TYPES_LIST_ID";
export const USER_TRANSACTIONS_LIST_ID = "USER_TRANSACTIONS_LIST_ID";
export const USER_AVAILABLE_REWARDS_LIST_ID = "USER_AVAILABLE_REWARDS_LIST_ID";
export const USER_CUSTOM_EVENTS_LIST_ID = "USER_CUSTOM_EVENTS_LIST_ID";
export const USER_ACHIEVEMENTS_STATUS_LIST_ID =
  "USER_ACHIEVEMENTS_STATUS_LIST_ID";
export const USER_TRIGGERS_HISTORY = "USER_TRIGGERS_HISTORY";
export const USER_CAMPAIGNS_STATUS_LIST_ID = "USER_CAMPAIGNS_STATUS_LIST_ID";
export const USER_VISIBLE_CAMPAIGNS_LIST_ID = "USER_VISIBLE_CAMPAIGNS_LIST_ID";
export const WEBHOOK_LIST_ID = "WEBHOOK_LIST_ID";
export const IMPORTS_LIST_ID = "IMPORTS_LIST_ID";
export const MEMBER_IMPORT_DETAILS_LIST_ID = "MEMBER_IMPORT_DETAILS_LIST_ID";
export const TRANSACTION_IMPORT_DETAILS_LIST_ID =
  "TRANSACTION_IMPORT_DETAILS_LIST_ID";
export const GROUP_OF_VALUES_IMPORT_DETAILS_LIST_ID =
  "GROUP_OF_VALUES_IMPORT_DETAILS_LIST_ID";
export const ADDING_UNIT_TRANSFER_IMPORT_DETAILS_LIST_ID =
  "ADDING_UNIT_TRANSFER_IMPORT_DETAILS_LIST_ID";
export const SPENDING_UNIT_TRANSFER_IMPORT_DETAILS_LIST_ID =
  "SPENDING_UNIT_TRANSFER_IMPORT_DETAILS_LIST_ID";
export const COUPONS_IMPORT_DETAILS_LIST_ID = "COUPONS_IMPORT_DETAILS_LIST_ID";
export const REDEMPTION_CODES_LIST_ID = "REDEMPTION_CODES_LIST_ID";
export const EXPORTS_LIST_ID = "EXPORTS_LIST_ID";
export const RECOMMENDED_PRODUCTS_LIST_ID = "RECOMMENDED_PRODUCTS_LIST_ID";
export const TIMELINE_EVENTS_LIST_ID = "TIMELINE_EVENTS_LIST_ID";
export const ADDITIONAL_METRICS_ID = "ADDITIONAL_METRICS_ID";
export const SIMULATE_CAMPAIGN_LIST_ID = "SIMULATE_CAMPAIGN_ID";
export const SINGLE_REWARD_FULFILLMENTS_ID = "SINGLE_REWARD_FULFILLMENTS_ID";
export const MATCHED_MEMBER_LIST_ID = "MATCHED_MEMBER_LIST_ID";
export const PRODUCTS_LIST_ID = "PRODUCTS_LIST_ID";
export const UNIT_TRANSFER_MODAL_ID = "UNIT_TRANSFER_MODAL_ID";
export const ACHIEVEMENT_STATUS_ID = "ACHIEVEMENT_STATUS_ID";
export const CUSTOM_ATTRIBUTES_ID = "CUSTOM_ATTRIBUTES_ID";
export const COLLECTIONS_LIST_ID = "COLLECTIONS_LIST_ID";
export const SINGLE_COLLECTION_VALUES_LIST_ID =
  "SINGLE_COLLECTION_VALUES_LIST_ID";
export const SINGLE_TRANSACTION_RELATED_TRANSACTIONS =
  "SINGLE_TRANSACTION_RELATED_TRANSACTIONS";
export const MEMBER_MATCHED_EVENT_ID = "MEMBER_MATCHED_EVENT_ID";
export const CAMPAING_IMPORT_SUCCESS_ID = "CAMPAING_IMPORT_SUCCESS_ID";
export const CAMPAING_IMPORT_UNSUCCESS_ID = "CAMPAING_IMPORT_UNSUCCESS_ID";
export const REFERRAL_IMPORT_SUCCESS_ID = "REFERRAL_IMPORT_SUCCESS_ID";
export const REFERRAL_IMPORT_UNSUCCESS_ID = "REFERRAL_IMPORT_UNSUCCESS_ID";
export const ACHIEVEMENT_IMPORT_SUCCESS_ID = "ACHIEVEMENT_IMPORT_SUCCESS_ID";
export const ACHIEVEMENT_IMPORT_UNSUCCESS_ID =
  "ACHIEVEMENT_IMPORT_UNSUCCESS_ID";
export const CUSTOM_EVENT_SCHEMA_SUCCESS_ID = "CUSTOM_EVENT_SCHEMA_SUCCESS_ID";
export const CUSTOM_EVENT_SCHEMA_UNSUCCESS_ID =
  "CUSTOM_EVENT_SCHEMA_UNSUCCESS_ID";
export const UNITS_EARNED_FROM_TRANSACTION_ID =
  "UNITS_EARNED_FROM_TRANSACTION_ID";
export const REWARDS_EARNED_FROM_TRANSACTION_ID =
  "REWARDS_EARNED_FROM_TRANSACTION_ID";
export const UNITS_EARNED_FROM_CUSTOM_EVENT_ID =
  "UNITS_EARNED_FROM_CUSTOM_EVENT_ID";
export const REWARDS_EARNED_FROM_CUSTOM_EVENT_ID =
  "REWARDS_EARNED_FROM_CUSTOM_EVENT_ID";
export const REWARD_IMPORT_SUCCESS_ID = "REWARD_IMPORT_SUCCESS_ID";
export const REWARD_IMPORT_UNSUCCESS_ID = "REWARD_IMPORT_UNSUCCESS_ID";
export const TIERSET_LIST_ID = "TIERSET_LIST_ID";
export const ACTIONS_LIST_ID = "ACTIONS_LIST_ID";
export const ACTION_DETAILS_LIST_ID = "ACTION_DETAILS_LIST_ID";
export const GLOBAL_MANAGEMENT_WALLET_TYPES_LIST_ID =
  "GLOBAL_MANAGEMENT_WALLET_TYPES_LIST_ID";
export const WALLET_IMPORT_SUCCESS_ID = "WALLET_IMPORT_SUCCESS_ID";
export const WALLET_IMPORT_UNSUCCESS_ID = "WALLET_IMPORT_UNSUCCESS_ID";
export const GLOBAL_MANAGEMENT_CUSTOM_EVENTS_SCHEMA_LIST_ID =
  "GLOBAL_MANAGEMENT_CUSTOM_EVENTS_SCHEMA_LIST_ID";
export const GLOBAL_MANAGEMENT_REWARD_LIST_ID =
  "GLOBAL_MANAGEMENT_REWARD_LIST_ID";
export const GLOBAL_MANAGEMENT_ACHIEVEMENTS_LIST_ID =
  "GLOBAL_MANAGEMENT_ACHIEVEMENTS_LIST_ID";
export const GLOBAL_MANAGEMENT_CAMPAIGNS_LIST_ID =
  "GLOBAL_MANAGEMENT_CAMPAIGNS_LIST_ID";
export const GLOBAL_MANAGEMENT_REFERRALS_LIST_ID =
  "GLOBAL_MANAGEMENT_REFERRALS_LIST_ID";
export const SINGLE_TRANSACTION_TRIGGERED_ACHIEVEMENTS_ID =
  "SINGLE_TRANSACTION_TRIGGERED_ACHIEVEMENTS_ID";
export const SINGLE_EVENT_TRIGGERED_ACHIEVEMENTS_ID =
  "SINGLE_EVENT_TRIGGERED_ACHIEVEMENTS_ID";
export const CAMPAIGN_AUTOMATION_LIST_ID = "CAMPAIGN_AUTOMATION_LIST_ID";
export const CAMPAING_AUTOMATION_IMPORT_SUCCESS_ID =
  "CAMPAING_AUTOMATION_IMPORT_SUCCESS_ID";
export const CAMPAING_AUTOMATION_IMPORT_UNSUCCESS_ID =
  "CAMPAING_AUTOMATION_IMPORT_UNSUCCESS_ID";
export const GLOBAL_MANAGEMENT_AUTOMATIONS_LIST_ID =
  "GLOBAL_MANAGEMENT_AUTOMATIONS_LIST_ID";
export const MEMBER_LIST_BADGES_ID = "MEMBER_LIST_BADGES_ID";
export const LEADERBOARD_LIST_ID = "LEADERBOARD_LIST_ID";
export const LEADERBOARD_RANKING_LIST_ID = "LEADERBOARD_RANKING_LIST_ID";
export const MEMBER_LEADERBOARD_LIST_ID = "MEMBER_LEADERBOARD_LIST_ID";
